// @flow
import React, { useEffect, useState } from 'react';

import { commaJoin } from 'app/common/lib/address';


type StudentInfo = {
  id: number,
  classTitle?: string,
  name?: string,
}

type Props = {
  id: number,
  name: string,
  type: 'Employee' | 'Student' | 'Parent',
  className?: string,
  onStudentRequest?: (id: number) => Promise<StudentInfo>,
}

const ReceiverItem = ({
  id,
  name,
  type,
  className,
  onStudentRequest,
}: Props) => {
  const [studentInfo, setStudentInfo] = useState<StudentInfo>(() => ({ id }));
  // const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (onStudentRequest && type === 'Student') {
      (async () => {
        // setLoading(true);
        const info = await onStudentRequest(id);
        setStudentInfo(info);
        // setLoading(false);
      })();
    }
  }, [id, type]); // eslint-disable-line react-hooks/exhaustive-deps

  const receiverString = commaJoin(
    studentInfo.name || name,
    studentInfo.classTitle,
  );

  if (type === 'Student') {
    return (
      <span className={className}>
        {receiverString}
      </span>
    );
  }

  return (
    <span className={className}>{name}</span>
  );
};

export default ReceiverItem;
